import React from "react";
import {makeStyles} from "@material-ui/styles";
import UnderlinedLabel from "../../UnderlinedLabel";
import CalculatorTile from "../CalculatorTile";
import Grid from "@material-ui/core/Grid";


const useStyles = makeStyles(theme => ({
    root: {
        marginTop: '20px',
        marginBottom: '20px'
    }
}));

const CalculatorCategoryBox = (props) => {
    const styles = useStyles();

    return (
        <div>
            <UnderlinedLabel title = {props.title}/>
            <div className={styles.root}>
                <Grid container spacing={2}>
                    {props.sheets.map(sheet => (
                        <Grid item xs={12} sm={6} md={4} xl={4}>
                            <CalculatorTile name={sheet.name}/>
                        </Grid>
                    ))}
                </Grid>
            </div>
        </div>
    )
};

export default CalculatorCategoryBox;